export const server = "https://sparkfly-backend.onrender.com/api/v2";

export const backend_url = "https://sparkfly-backend.onrender.com/";
